import React from 'react';
import { Tag } from 'antd';
import {
  LastChanceDisplayStatus,
  LastChanceStatusInput,
  LAST_CHANCE_DISPLAY_STATUS_LABELS,
  LAST_CHANCE_DISPLAY_STATUS_TAG_COLORS,
  resolveLastChanceDisplayStatus,
} from '@utils/last-chance-status';

interface LastChanceStatusTagProps {
  item: LastChanceStatusInput;
  displayStatus?: LastChanceDisplayStatus;
}

const LastChanceStatusTag: React.FC<LastChanceStatusTagProps> = ({ item, displayStatus }) => {
  const status = displayStatus ?? resolveLastChanceDisplayStatus(item);

  return <Tag color={LAST_CHANCE_DISPLAY_STATUS_TAG_COLORS[status]}>{LAST_CHANCE_DISPLAY_STATUS_LABELS[status]}</Tag>;
};

export default LastChanceStatusTag;
